import React, { ReactElement } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";

interface FullPageLoaderProps {
	message?: string;
}

export default function FullPageLoader(props: FullPageLoaderProps): ReactElement {
	return (
		<Flex flexDir={"column"} justifyContent={"space-between"} minHeight={"100vh"}>
			<Box></Box>
			<Box textAlign={"center"}>
				<Box display={"inline-block"} mx={"auto"}>
					<svg version="1.1" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24">
						<rect x="0" y="0" width="4" height="7" fill="#333">
							<animateTransform
								attributeType="xml"
								attributeName="transform"
								type="scale"
								values="1,1; 1,3; 1,1"
								begin="0s"
								dur="0.6s"
								repeatCount="indefinite"
							/>
						</rect>
						<rect x="10" y="0" width="4" height="7" fill="#333">
							<animateTransform
								attributeType="xml"
								attributeName="transform"
								type="scale"
								values="1,1; 1,3; 1,1"
								begin="0.2s"
								dur="0.6s"
								repeatCount="indefinite"
							/>
						</rect>
						<rect x="20" y="0" width="4" height="7" fill="#333">
							<animateTransform
								attributeType="xml"
								attributeName="transform"
								type="scale"
								values="1,1; 1,3; 1,1"
								begin="0.4s"
								dur="0.6s"
								repeatCount="indefinite"
							/>
						</rect>
					</svg>
				</Box>
				{props.message && <Text mt={5}>{props.message}</Text>}
			</Box>
			<Box></Box>
		</Flex>
	);
}
